import React from "react";
import logo from "../assets/logohorizental.png";
import { useNavigate, useLocation } from "react-router-dom";
import { getRouteModule, hasAdminPermission } from "../utils/adminPermissions";

function Sidebar({
  collapsed,
  setCollapsed,
  screenSize,
  mobileMenu,
  setMobileMenu,
  openMenu,
  setOpenMenu,
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const currentUser = (() => {
    try {
      return JSON.parse(localStorage.getItem("user") || "{}");
    } catch (error) {
      return {};
    }
  })();
  const adminTypeLabel = currentUser.admin_type || currentUser.name || "Master Admin";

  const menuItems = [
    {
      icon: "bi-house",
      label: "Home",
      path: "/dashboard",
    },
    {
      icon: "bi-book",
      label: "Course",
      children: [
        { label: "Course Module", path: "/dashboard/course-modules" },
        { label: "Course Category", path: "/dashboard/course-categories" },
        { label: "Our Courses", path: "/dashboard/our-courses" },
        { label: "Course Fees", path: "/dashboard/course-fees" },
      ],
    },
    {
      icon: "bi-diagram-3",
      label: "Franchise",
      children: [
        { label: "New Application", path: "/dashboard/franchise-application" },
        { label: "Applied Franchise", path: "/dashboard/new-franchise" },
        { label: "Active Franchise", path: "/dashboard/view-franchise" },
        { label: "Hold/Reject Franchise", path: "/dashboard/hold-reject-franchise" },
        { label: "Blacklisted Franchise", path: "/dashboard/blacklisted-franchise" },
        { label: "Total Franchise", path: "/dashboard/total-franchise" },
      ],
    },
    {
      icon: "bi-people",
      label: "Student",
      children: [
        { label: "New Application", path: "/dashboard/student-application" },
        { label: "View Application", path: "/dashboard/view-application" },
        { label: "View Registered Student", path: "/dashboard/view-student" },
        { label: "Exam Complete", path: "/dashboard/exam-complete" },
        { label: "Certified Student", path: "/dashboard/certified-student" },
        { label: "Our Student", path: "/dashboard/our-student" },
      ],
    },
    {
      icon: "bi-play-btn",
      label: "Training",
      children: [{ label: "Franchise Training", path: "/dashboard/franchise-training" }],
    },
    {
      icon: "bi-inboxes",
      label: "Front Office",
      children: [
        { label: "Postal Order", path: "/dashboard/postal-order" },
        { label: "Postal Dispatch", path: "/dashboard/postal-dispatch" },
      ],
    },
    {
      icon: "bi-wallet2",
      label: "Payment",
      children: [
        { label: "Payout Request", path: "/dashboard/payout" },
        { label: "Load Wallet Request", path: "/dashboard/deposit" },
        { label: "View Money Request", path: "/dashboard/view-deposit" },
        { label: "New Deduct", path: "/dashboard/deduct" },
        { label: "View Deduct", path: "/dashboard/view-deduct" },
        { label: "Online Payment", path: "/dashboard/online-payment" },
      ],
    },
    {
      icon: "bi-receipt",
      label: "Account Info",
      children: [{ label: "View Statement", path: "/dashboard/statement" }],
    },
    {
      icon: "bi-file-earmark-text",
      label: "Exam",
      children: [
        { label: "New Exam", path: "/dashboard/new-exam" },
        { label: "View Exam", path: "/dashboard/view-exam" },
        { label: "New MCQ Question", path: "/dashboard/new-mcq" },
        { label: "View MCQ Question", path: "/dashboard/view-mcq" },
        { label: "CSV Upload", path: "/dashboard/csv-upload" },
        { label: "Online Exam Result", path: "/dashboard/exam-result" },
      ],
    },
      {
        icon: "bi-award",
        label: "Certification",
        children: [
          { label: "Marksheet Download", path: "/dashboard/marksheet" },
          { label: "Certificate Download", path: "/dashboard/certificate" },
          { label: "Grade Point Setting", path: "/dashboard/new-grade" },
          { label: "AMCI Design", path: "/dashboard/amci-design" },
        ],
      },
    {
      icon: "bi-gear",
      label: "Settings",
      children: [
        { label: "Home Page Setting", path: "/dashboard/home-setting" },
        { label: "About Us Page", path: "/dashboard/about-setting" },
        { label: "Session Control", path: "/dashboard/session-control" },
        { label: "Franchise T&C", path: "/dashboard/franchise-tc" },
        { label: "Download Page", path: "/dashboard/download-setting" },
        { label: "Gallery", path: "/dashboard/gallery" },
        { label: "Topbar & Footer", path: "/dashboard/topbar-footer-setting" },
        { label: "User Controller", path: "/dashboard/admin-users" },
        { label: "Contact Us", path: "/dashboard/contact" },
        { label: "State Setting", path: "/dashboard/state" },
        { label: "District Setting", path: "/dashboard/district" },
      ],
    },
    {
      icon: "bi-chat-dots",
      label: "Message",
      children: [
        { label: "New Message", path: "/dashboard/new-message" },
        { label: "Feedback Box", path: "/dashboard/feedback-box" },
        { label: "Ticket System", path: "/dashboard/ticket-system" },
      ],
    },
  ];

  const isMainActive = (item) =>
    item.path
      ? location.pathname === item.path
      : item.children?.some((sub) => location.pathname === sub.path);

  const canSeePath = (path) => hasAdminPermission(getRouteModule(path), "view");
  const visibleMenuItems = menuItems
    .map((item) => {
      if (item.children) {
        const children = item.children.filter((sub) => canSeePath(sub.path));
        return children.length ? { ...item, children } : null;
      }

      return canSeePath(item.path) ? item : null;
    })
    .filter(Boolean);

  return (
    <>
      <style>
        {`
          .admin-sidebar {
            scrollbar-width: none;
            -ms-overflow-style: none;
          }
          .admin-sidebar::-webkit-scrollbar {
            display: none;
            width: 0;
            height: 0;
          }
        `}
      </style>
      {mobileMenu && screenSize <= 768 && (
        <div
          onClick={() => setMobileMenu(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(78, 27, 36, 0.22)",
            backdropFilter: "blur(4px)",
            zIndex: 1900,
          }}
        />
      )}

      <div
        className="admin-sidebar"
        onMouseEnter={() => {
          if (screenSize <= 1040 && screenSize > 768) setCollapsed(false);
        }}
        onMouseLeave={() => {
          if (screenSize <= 1040 && screenSize > 768) setCollapsed(true);
        }}
        style={{
          width: screenSize <= 768 ? "280px" : collapsed ? "72px" : "248px",
          height: "100vh",
          background: "linear-gradient(180deg, #dbeafe 0%, #f8fafc 38%, #fff7ed 100%)",
          color: "#4e1b24",
          transition: "0.3s ease",
          position: "fixed",
          top: 0,
          left: 0,
          zIndex: 2000,
          overflowY: "auto",
          overflowX: "hidden",
          paddingBottom: "24px",
          borderRight: "1px solid rgba(148, 163, 184, 0.18)",
          boxShadow: "18px 0 45px rgba(148, 163, 184, 0.18)",
          scrollbarWidth: "none",
          msOverflowStyle: "none",
          transform:
            screenSize <= 768
              ? mobileMenu
                ? "translateX(0)"
                : "translateX(-100%)"
              : "none",
        }}
      >
        <div
          style={{
            padding: collapsed && screenSize > 768 ? "18px 10px" : "20px 16px 18px",
            borderBottom: "1px solid rgba(148, 163, 184, 0.16)",
          }}
        >
          <div
            style={{
              background: "linear-gradient(135deg, rgba(255,255,255,0.72) 0%, rgba(255,237,213,0.88) 100%)",
              border: "1px solid rgba(148, 163, 184, 0.16)",
              borderRadius: "22px",
              padding: collapsed && screenSize > 768 ? "10px 6px" : "14px 12px",
              textAlign: "center",
              boxShadow: "0 18px 34px rgba(148, 163, 184, 0.14)",
              position: "relative",
            }}
          >
            {screenSize <= 768 && (
              <button
                type="button"
                onClick={() => setMobileMenu(false)}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  width: "34px",
                  height: "34px",
                  borderRadius: "999px",
                  border: "none",
                  background: "linear-gradient(135deg, #7c2d3a 0%, #c2410c 100%)",
                  color: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 12px 20px rgba(124, 45, 58, 0.24)",
                  cursor: "pointer",
                }}
              >
                <i className="bi bi-x-lg"></i>
              </button>
            )}
            <img
              src={logo}
              alt="logo"
              style={{ width: collapsed && screenSize > 768 ? "42px" : "78%", maxWidth: "150px" }}
            />
            {(screenSize > 1040 || !collapsed) && (
              <div style={{ marginTop: "12px" }}>
                <p
                  style={{
                    margin: 0,
                    fontSize: "11px",
                    letterSpacing: "0.14em",
                    textTransform: "uppercase",
                    color: "rgba(78, 27, 36, 0.64)",
                  }}
                >
                  {adminTypeLabel}
                </p>
                <p style={{ margin: "4px 0 0", fontSize: "13px", color: "#7c2d3a", fontWeight: 700 }}>
                  Control Workspace
                </p>
              </div>
            )}
          </div>
        </div>

        <div style={{ marginTop: "12px", padding: "0 10px" }}>
          {visibleMenuItems.map((item, index) => {
            const itemActive = isMainActive(item);

            return (
              <div key={index}>
                <div
                  onClick={() => {
                    if (item.children) {
                      setOpenMenu(openMenu === index ? null : index);
                    } else {
                      navigate(item.path);
                      if (screenSize <= 768) setMobileMenu(false);
                    }
                  }}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: collapsed && screenSize > 768 ? "12px 10px" : "12px 14px",
                    cursor: "pointer",
                    margin: "6px 0",
                    borderRadius: "16px",
                    transition: "0.2s ease",
                    background: itemActive ? "linear-gradient(135deg, #7c2d3a 0%, #c2410c 100%)" : "transparent",
                    border: itemActive ? "1px solid rgba(124, 45, 58, 0.18)" : "1px solid transparent",
                    boxShadow: itemActive ? "0 16px 28px rgba(124, 45, 58, 0.20)" : "none",
                  }}
                  onMouseEnter={(e) => {
                    if (!itemActive) {
                      e.currentTarget.style.background = "linear-gradient(135deg, #7c2d3a 0%, #c2410c 100%)";
                      e.currentTarget.style.boxShadow = "0 16px 28px rgba(124, 45, 58, 0.20)";
                      e.currentTarget.style.transform = "translateX(4px)";
                      e.currentTarget.style.border = "1px solid rgba(124, 45, 58, 0.12)";
                      const icon = e.currentTarget.querySelector(".sidebar-main-icon");
                      const label = e.currentTarget.querySelector(".sidebar-main-label");
                      const arrow = e.currentTarget.querySelector(".sidebar-main-arrow");
                      if (icon) icon.style.color = "#ffffff";
                      if (label) label.style.color = "#ffffff";
                      if (arrow) arrow.style.color = "rgba(255,255,255,0.84)";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (!itemActive) {
                      e.currentTarget.style.background = "transparent";
                      e.currentTarget.style.boxShadow = "none";
                      e.currentTarget.style.transform = "translateX(0)";
                      e.currentTarget.style.border = "1px solid transparent";
                      const icon = e.currentTarget.querySelector(".sidebar-main-icon");
                      const label = e.currentTarget.querySelector(".sidebar-main-label");
                      const arrow = e.currentTarget.querySelector(".sidebar-main-arrow");
                      if (icon) icon.style.color = "#7c2d3a";
                      if (label) label.style.color = "#4e1b24";
                      if (arrow) arrow.style.color = "rgba(78, 27, 36, 0.58)";
                    }
                  }}
                >
                  <div style={{ display: "flex", gap: "12px", alignItems: "center", minWidth: 0 }}>
                    <div
                      style={{
                        width: "34px",
                        height: "34px",
                        borderRadius: "12px",
                        background: itemActive ? "rgba(255,255,255,0.18)" : "rgba(124, 45, 58, 0.08)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                      }}
                    >
                      <i className={`bi ${item.icon} sidebar-main-icon`} style={{ fontSize: "16px", color: itemActive ? "#ffffff" : "#7c2d3a" }}></i>
                    </div>

                    {(screenSize > 1040 || !collapsed) && (
                      <span className="sidebar-main-label" style={{ fontSize: "14px", fontWeight: 600, color: itemActive ? "#ffffff" : "#4e1b24", whiteSpace: "nowrap" }}>
                        {item.label}
                      </span>
                    )}
                  </div>

                  {item.children && (screenSize > 1040 || !collapsed) && (
                    <i
                      className={`bi ${openMenu === index ? "bi-chevron-up" : "bi-chevron-down"} sidebar-main-arrow`}
                      style={{ color: itemActive ? "rgba(255,255,255,0.84)" : "rgba(78, 27, 36, 0.58)", fontSize: "13px" }}
                    ></i>
                  )}
                </div>

                {openMenu === index && item.children && (
                  <div
                    style={{
                      margin: "4px 0 8px 16px",
                      paddingLeft: "16px",
                      borderLeft: "1px solid rgba(124, 45, 58, 0.14)",
                    }}
                  >
                    {item.children.map((sub, i) => {
                      const subActive = location.pathname === sub.path;

                      return (
                        <div
                          key={i}
                          onClick={() => {
                            navigate(sub.path);
                            if (screenSize <= 768) setMobileMenu(false);
                          }}
                          style={{
                            padding: "10px 12px",
                            cursor: "pointer",
                            fontSize: "13px",
                            borderRadius: "12px",
                            transition: "0.2s ease",
                            background: subActive ? "rgba(124, 45, 58, 0.10)" : "transparent",
                            color: subActive ? "#7c2d3a" : "#6b3140",
                            marginBottom: "4px",
                            border: subActive ? "1px solid rgba(124, 45, 58, 0.14)" : "1px solid transparent",
                          }}
                          onMouseEnter={(e) => {
                            if (!subActive) {
                              e.currentTarget.style.background = "linear-gradient(135deg, #7c2d3a 0%, #c2410c 100%)";
                              e.currentTarget.style.paddingLeft = "16px";
                              e.currentTarget.style.boxShadow = "0 12px 20px rgba(124, 45, 58, 0.14)";
                              e.currentTarget.style.border = "1px solid rgba(124, 45, 58, 0.12)";
                              e.currentTarget.style.color = "#ffffff";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!subActive) {
                              e.currentTarget.style.background = "transparent";
                              e.currentTarget.style.paddingLeft = "12px";
                              e.currentTarget.style.boxShadow = "none";
                              e.currentTarget.style.border = "1px solid transparent";
                              e.currentTarget.style.color = "#6b3140";
                            }
                          }}
                        >
                          <span style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 500 }}>
                            <i className="bi bi-chevron-right" style={{ fontSize: "11px" }}></i>
                            {sub.label}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div style={{ padding: "18px 14px 0", marginTop: "6px" }}>
          {(screenSize > 1040 || !collapsed) && (
            <div
              style={{
                background: "linear-gradient(135deg, rgba(255,255,255,0.72) 0%, rgba(255,237,213,0.88) 100%)",
                border: "1px solid rgba(148, 163, 184, 0.16)",
                borderRadius: "18px",
                padding: "14px 12px",
                color: "#7c2d3a",
                boxShadow: "0 18px 34px rgba(148, 163, 184, 0.12)",
              }}
            >
              <p
                style={{
                  margin: 0,
                  fontSize: "11px",
                  textTransform: "uppercase",
                  letterSpacing: "0.12em",
                  color: "rgba(78, 27, 36, 0.58)",
                }}
              >
                Admin Panel
              </p>
              <p style={{ margin: "6px 0 0", fontSize: "13px", lineHeight: 1.5 }}>
                Daily operations, student approval and franchise monitoring in one place.
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default Sidebar;
